import { Link } from "@tanstack/react-router";
import type { SubmissionBrief, SubmissionView } from "@/app/reviewQueries";
import { StatusChip } from "@/ui/StatusChip";
import { commentsLabel, fmtWhen, rootCount, runScore, STATUS_CHIP } from "./model";

const ORDINAL = ["", "Первая", "Вторая", "Третья"];
/** «Вторая из трёх до эскалации на созвон.» — порог 3 (открытый вопрос CLAUDE.md). */
export function iterationText(n: number, threshold = 3): string {
  const word = ORDINAL[n] ?? `${n}-я`;
  return n <= threshold ? `${word} из трёх до эскалации на созвон.` : `${word} — порог эскалации пройден, ментор предложит созвон.`;
}

/** Левая колонка S7: версии сдачи (новые сверху), текущая выделена. */
export function Versions({ assignmentId, list, current }: { assignmentId: string; list: SubmissionBrief[]; current?: SubmissionView }) {
  return (
    <div className="flex h-full flex-col">
      <div className="border-b border-bd px-3.5 py-2.5 font-mono text-[11px] uppercase tracking-[.06em] text-mut">версии сдачи</div>
      <div className="flex flex-col gap-2 px-3 pb-4 pt-3">
        {list.map((b) => {
          const on = current?.id === b.id;
          const score = on && current ? runScore(current) : undefined;
          return (
            <Link
              key={b.id}
              to="/notebook/$assignmentId/review"
              params={{ assignmentId }}
              search={{ submission: b.id }}
              data-testid="version"
              aria-current={on ? "true" : undefined}
              className="flex flex-col gap-1.5 rounded-md px-3 py-2.5 no-underline"
              style={{ background: on ? "var(--card)" : "transparent", border: `1px solid ${on ? "var(--acc)" : "var(--bd)"}`, color: on ? "var(--ink)" : "var(--ink2)" }}
            >
              <span className="flex items-baseline justify-between gap-2 font-mono text-[12px]">
                <span>
                  v{b.iteration}
                  {on ? " · текущая" : ""}
                </span>
                <span className="text-[10.5px] text-ink2">{fmtWhen(b.submitted_at)}</span>
              </span>
              <StatusChip status={STATUS_CHIP[b.status]} compact />
              {on && current && (
                <span className="font-mono text-[10.5px] text-ink2">
                  {score ? `${score.passed}/${score.total} · ` : ""}
                  {commentsLabel(rootCount(current))}
                </span>
              )}
            </Link>
          );
        })}
      </div>
      <div className="mt-auto border-t border-bd px-3.5 py-3">
        <div className="font-mono text-[11px] uppercase tracking-[.06em] text-mut">итерация</div>
        <p className="mb-0 mt-1.5 text-[12.5px] leading-[1.5] text-ink2" data-testid="iteration">
          {iterationText(Math.max(...list.map((b) => b.iteration), 1))}
        </p>
      </div>
    </div>
  );
}
